var r="\n    dBlendModeFogFactor = 0.0;\n    rgb *= saturate(gammaCorrectInput(max(a, 0.0)));\n    if ((rgb.r + rgb.g + rgb.b) < 0.000001) discard;\n";export{r as default};
